import { COLORS } from '@constants';
import { Card } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';
import { GUIDELINE_MODAL_TOP, GUIDELINE_MODAL_WRAP_CLASS } from './constants';

export const StyledCard = styled(Card)`
    position: relative;
    overflow: hidden;
`;

export const StyledContent = styled.div`
    max-width: calc(100% - 282px);
    min-height: 270px;
    padding: 10px 0 0 10px;

    @media (max-width: 991px) {
        max-width: none;
        min-height: 0;
    }
`;

export const StyledList = styled.ol`
    text-align: left;
    list-style-position: outside;
    padding-left: 20px;
    margin: 0 0 24px;
    font-size: 14px;
    font-weight: normal;
    line-height: 24px;
    color: ${COLORS.$gray60Black};
`;

// Figma: 295x293 crop of the screenshot, flush with the card's bottom-right corner
export const StyledThumbnail = styled.div`
    position: absolute;
    right: 0;
    bottom: 0;
    width: 295px;
    height: 293px;
    border-top-left-radius: 8px;
    border-bottom-right-radius: 8px;
    background: url(${({ $src }) => $src}) top left / 488px auto no-repeat;

    @media (max-width: 991px) {
        position: static;
        width: 100%;
        margin-top: 24px;
        border-radius: 8px;
    }
`;

// Figma: 1152x1065 (modal 1200px wide minus 24px padding on each side)
export const StyledModalImage = styled.img`
    display: block;
    width: 100%;
    max-width: 1152px;
    height: auto;
    aspect-ratio: 1152 / 1065;
    object-fit: cover;
    object-position: top left;
    border-radius: 8px;
`;

// antd focuses the dialog after opening; without this the focus scroll drops the top offset on short screens
export const GuidelineModalWrapStyle = createGlobalStyle`
    .${GUIDELINE_MODAL_WRAP_CLASS} {
        scroll-padding-top: ${GUIDELINE_MODAL_TOP}px;
    }
`;
